import { render, staticRenderFns } from "./WorkDistributionEditDialog.vue?vue&type=template&id=2d9caf97"
import script from "./WorkDistributionEditDialog.vue?vue&type=script&lang=js"
export * from "./WorkDistributionEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports